export function linkedInAddUrl({ name, issuer, issuedOn, code }) {
  const [, m, y] = (issuedOn || "").split(".");
  const p = new URLSearchParams({ startTask: "CERTIFICATION_NAME", name: name || "Zertifikat", certId: code || "", certUrl: `${window.location.origin}/zertifikat/${code}` });
  if (issuer) p.set("organizationName", issuer);
  if (y) p.set("issueYear", y);
  if (m) p.set("issueMonth", String(Number(m)));
  return `https://www.linkedin.com/profile/add?${p.toString()}`;
}
